import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';
import { HttpClient } from '@angular/common/http';
import { API_URL, API_STATUS, MESSAGE } from '../../constants/config';
import * as moment from 'moment';

@Injectable()
export class ProfileService {

  constructor(private http: HttpClient, private _common: CommonService) { }

  getCompanyInfo(data) {
    const getInfoUrl = `${API_URL}marketing/get-company-info`;
    return new Promise((resolve, reject) => {
      this._common.toggleLoading(true);
      this.http.post(getInfoUrl, data, { withCredentials: true }).subscribe((res: any) => {
        this._common.toggleLoading(false);
        if (res.Status === API_STATUS.error) {
          // this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        // localStorage.setItem('COMPANY_DATA', JSON.stringify(res.Data));
        resolve(res.Data);
      }, (err) => {
        this._common.toggleLoading(false);
        reject(err);
      });
    });
  }

  getPersonalInfo(data) {
    const getInfoUrl = `${API_URL}marketing/get-personal-info`;
    return new Promise((resolve, reject) => {
      this._common.toggleLoading(true);
      this.http.post(getInfoUrl, data, { withCredentials: true }).subscribe((res: any) => {
        this._common.toggleLoading(false);
        if (res.Status === API_STATUS.error) {
          // this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        // localStorage.setItem('PERSONAL_DATA', JSON.stringify(res.Data));
        resolve(res.Data);
      }, (err) => {
        this._common.toggleLoading(false);
        reject(err);
      });
    });
  }

  updateCompanyInfo(data) {
    const updateUrl = `${API_URL}marketing/update-company`;
    return new Promise((resolve, reject) => {
      this._common.toggleLoading(true);
      this.http.post(updateUrl, data, { withCredentials: true }).subscribe((res: any) => {
        this._common.toggleLoading(false);
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        // this._common.showToastr('success', MESSAGE.update_success, 'Congratulation!');
        resolve(res.Data);
      }, (err) => {
        this._common.toggleLoading(false);
        reject(err);
      });
    });
  }

  completeOnboard(data) {
    const updateUrl = `${API_URL}marketing/skip-onboard`;
    return new Promise((resolve, reject) => {
      this.http.post(updateUrl, data, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }

  updateIndividualInfo(data) {
    const updateUrl = `${API_URL}marketing/update-personal`;
    return new Promise((resolve, reject) => {
      this._common.toggleLoading(true);
      this.http.post(updateUrl, data, { withCredentials: true }).subscribe((res: any) => {
        this._common.toggleLoading(false);
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        localStorage.setItem('CURRENT_USER', JSON.stringify(res.Data));
        this._common.storageChanged(res.Data);
        this._common.onChangeProfile.next('change person info');
        // this._common.showToastr('success', MESSAGE.update_success, 'Congratulation!');
        resolve(res.Data);
      }, (err) => {
        this._common.toggleLoading(false);
        reject(err);
      });
    });
  }

  uploadCompanyPic(file) {
    const url = `${API_URL}marketing/update-company-image`;
    const formData: FormData = new FormData();
    formData.append('image', file);
    return new Promise((resolve, reject) => {
      this._common.toggleLoading(true);
      this.http.post(url, formData, { withCredentials: true }).subscribe((res: any) => {
        this._common.toggleLoading(false);
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        // this._common.showToastr('success', MESSAGE.update_success, 'Congratulation!');
        resolve(res.Data);
      }, (err) => {
        this._common.toggleLoading(false);
        reject(err);
      });
    });
  }

  uploadPersonalPic(file) {
    const url = `${API_URL}marketing/update-personal-image`;
    const formData: FormData = new FormData();
    formData.append('image', file);
    return new Promise((resolve, reject) => {
      this._common.toggleLoading(true);
      this.http.post(url, formData, { withCredentials: true }).subscribe((res: any) => {
        this._common.toggleLoading(false);
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        localStorage.setItem('CURRENT_USER', JSON.stringify(res.Data));
        this._common.storageChanged(res.Data);
        // this._common.showToastr('success', MESSAGE.update_success, 'Congratulation!');
        resolve(res.Data);
      }, (err) => {
        this._common.toggleLoading(false);
        reject(err);
      });
    });
  }

  getProfileProgress() {
    const url = `${API_URL}marketing/get-progress-info`;
    return new Promise((resolve, reject) => {
      this.http.get(url, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }

  saveBillingInfo(token) {
    const url = `${API_URL}marketing/create/payment`;
    return new Promise((resolve, reject) => {
      this.http.post(url, { token: token }, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        localStorage.setItem('CURRENT_USER', JSON.stringify(res.Data));
        this._common.storageChanged(res.Data);
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }

  getImpression(startDate, endDate) {
    const start = moment(startDate).format('YYYY-MM-DD');
    const end = moment(endDate).format('YYYY-MM-DD');
    const url = `${API_URL}marketing/get/impression?time_zone=${new Date().getTimezoneOffset() / -60}&start_date=${start}&end_date=${end}`;
    return new Promise((resolve, reject) => {
      this.http.get(url, { withCredentials: true }).subscribe((res: any) => {
        if (res.Status === API_STATUS.error) {
          // this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        reject(err);
      });
    });
  }

  getListPayment() {
    const url = `${API_URL}marketing/payments`;
    return new Promise((resolve, reject) => {
      this._common.toggleLoading(true);
      this.http.get(url, { withCredentials: true }).subscribe((res: any) => {
        this._common.toggleLoading(false);
        if (res.Status === API_STATUS.error) {
          this._common.showToastr('error', res.Message, 'An error occured!');
          reject(res.Message);
          return;
        }
        resolve(res.Data);
      }, (err) => {
        this._common.toggleLoading(false);
        reject(err);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/profile/profile.service.ts